import React from 'react';
import { Box, Container, Grid, Typography, useTheme } from '@mui/material';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const features = [
    {
        icon: 'images/service/service1.svg',
        title: 'SHIPPING',
        subtitle: 'Shipping In All India',
    },
    {
        icon: 'images/service/service2.svg',
        title: 'HASSLE FREE',
        subtitle: '24*7 Customer Support',
    },
    {
        icon: 'images/service/service3.svg',
        title: '7 DAYS',
        subtitle: 'Free & Easy Returns',
    },
    {
        icon: 'images/service/service4.svg',
        title: 'SECURED',
        subtitle: 'Quick Check Out Process',
    },
];

const FeaturesSection = () => {
    const theme = useTheme();

    return (
        <Box sx={{ bgcolor: 'black', color: 'white', py:6 ,position:'relative','&::after' : {
            content : '""',
            width:'100%',
            height:'1px',
            backgroundColor:'#fff',
            position:'absolute',
            zIndex:0,
            top:'50%',
            display:{md:'block',xs:'none'}
        }}}>
            <Container maxWidth='xl'>
                <Grid container sx={{position:'relative',zIndex:1,display:'flex',justifyContent:'space-between'}}>
                    {features.map((feature, index) => (
                        <Grid xs={12} sm={6} md={3} sx={{ padding: {xs:'20px 24px',sm:'20px 18px',md:'20px 20px'}, display: {sm:'flex',xs:'block'}, alignItems: 'center !important' ,backgroundColor:'#000'}}>
                            <Box  sx={{ display: 'flex', alignItems: 'center !important',justifyContent:{md:'center',xs:'start'},mb:{sm:0,xs:2} }}>
                                <img src={feature.icon} />
                            </Box>
                            <Box sx={{ padding: {sm:'0px 8px 0 16px',xs:'0 0 0 0'} ,display:'flex',justifyContent:{sm:'center',xs:'start'}}}>
                               <Box> 
                               <Typography variant="h6" sx={{ fontFamily: theme.palette.typography.fontFamily1, mb: 1.2, fontSize: '14px' }}>
                                    {feature.title}
                                </Typography>
                                <Typography variant="subtitle1" sx={{ fontFamily: theme.palette.typography.fontFamily1, fontSize: '20px' ,lineHeight:1.4,fontWeight:600}}>
                                    {feature.subtitle}
                                </Typography>
                               </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default FeaturesSection;
